export default {
  // Textos específicos de TimeAllocation
  includeInTotalHours: 'Incluir en el {totalHours}',
  hourType: 'Tipo de Horas',
  pedagogical: 'Pedagógicas',
  chronological: 'Cronológicas',
  attendanceRequired: '% de asistencia requerido',
  attendanceRequiredDefault: '% de asistencia requerido (Valor Predeterminado)',
  studentsPerHour: 'N° de estudiantes',
  studentsPerHourDefault: 'N° de estudiantes (Valor Predeterminado)',
  attendanceValidation: 'Este campo debe ser mayor o igual a cero y menor o igual a 100.',
  orderValidation: 'Este campo debe ser mayor o igual a cero y menor o igual a 100.',
  associateWith: 'Asociar a {entity}',
  yes: 'SI',
  no: 'NO',
  noApply: 'NO APLICA',
  includeInTotalHoursDefault: 'Incluir en el Total de Horas (Valor Predeterminado)',
  requiredForTeacherProfiles: 'Este objeto es necesarios para el funcionamiento de los perfiles de docentes.',
  requiredForDidacticBriefcase: 'Este objeto es necesarios para el funcionamiento de la maleta didáctica.',
}
